module.exports = __webpack_public_path__ + "static/media/ke.b150d6ce.svg";